var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "left-sidebar" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "scroll-sidebar" }, [
      _c(
        "nav",
        { staticClass: "sidebar-nav m-t-40" },
        [
          _vm.getConfig("maintenance_mode")
            ? _c("div", { staticClass: "text-center" }, [
                _c("span", { staticClass: "badge badge-danger m-b-10" }, [
                  _vm._v(_vm._s(_vm.trans("configuration.under_maintenance"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.getConfig("mode")
            ? _c("div", { staticClass: "text-center" }, [
                _c("span", { staticClass: "badge badge-danger m-b-10" }, [
                  _vm._v(_vm._s(_vm.trans("configuration.test_mode"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("main-menu"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "navbar-brand", attrs: { href: "/account/dashboard" } },
      [
        _c("img", {
          staticStyle: { "max-width": "210px" },
          attrs: { src: "/images/logo_white.svg" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }